import { Services, regExp } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import routesFormTitle from '@/components/services/routes/form/title'
import serversProperties from '@/components/services/servers/properties'

function renderTitleField(h) {
  return h(
    routesFormTitle,
    {
      props: {
        value: this.proxy,
        serviceName: Services.servers
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderHostField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.host,
        label: this.getTranslate(`${Services.servers}.labels.host`),
        hint: this.getTranslate(`${Services.servers}.hints.host`),
        dense: true,
        clearable: true,
        required: true,
        details: true
      },
      on: {
        input: event => {
          this.proxy.host = event
        }
      }
    }
  )
}

function renderPortField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.port,
        label: this.getTranslate(`${Services.servers}.labels.port`),
        hint: this.getTranslate(`${Services.servers}.hints.port`),
        dense: true,
        clearable: true,
        required: true,
        details: true,
        mask: regExp.ports
      },
      on: {
        input: event => {
          this.proxy.port = event
        }
      }
    }
  )
}

function renderProcessorField(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.processor,
        label: this.getTranslate(`${Services.servers}.labels.processor`),
        items: this.processors,
        loading: this.processorsLoading,
        required: true,
        autocomplete: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.processor = event
        }
      }
    }
  )
}

function renderProperties(h) {
  return h(
    serversProperties,
    {
      props: {
        value: this.proxy.properties,
        processor: this.proxy.processor
      },
      on: {
        input: event => {
          this.proxy.properties = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${Services.servers}-form`]: true,
        [`${Services.servers}-form--new`]: this.isNew
      }
    },
    [
      renderTitleField.call(this, h),
      renderHostField.call(this, h),
      renderPortField.call(this, h),
      renderProcessorField.call(this, h),
      renderProperties.call(this, h)
    ]
  )
}
